import { FC, useContext } from "react"
import { Link, useNavigate } from "react-router-dom";

import PracticeContactInfo from "src/components/practiceContactInfo";
import { AuthContext } from "src/context/authContext";
import { PROVIDER_HEADER } from "src/constants/manufacturer";
import { isMobileOrTablet, objectToQueryString } from "src/helpers";
import { providerProps } from "./types";




const Provider: FC<providerProps> = ({ providerList,defaultQueryParams }): JSX.Element => {
  const { userData } = useContext(AuthContext)
  const navigate = useNavigate();
  const navigateToScreenAndStorage = () => {
    localStorage.setItem('changeRole',"Manufacturer")
    navigate("/statistics")
  }
  return (
    <div className="card p-0">
      <div className="d-flex flex-column flex-fill">
        <div className="card-header bg-success-subtle order-1">
         <div className="row"> <div className="col-6 text-start">
            <h1 className="mb-0 p-0 text-start" style={{ color: '#008853', fontSize: '1.875rem' }}>Providers</h1>

          </div>
          <div className="col-6 text-end">
            {userData && userData.ref_type === "regional_manager" && <button onClick={()=>navigateToScreenAndStorage() } className="btn btn-sm btn-info btn-blue no-underline">National View</button>}

          </div>
          </div>
        </div>
        <div className="order-2 card-body p-0 overflow-y-auto" style={{ maxHeight: 350 }}>
          <table className="table table-responsive table-hover">
            <thead className="table-light sticky-top">
              <tr>
                {PROVIDER_HEADER.map((tableHeader, index) => (
                  <th
                    key={index}
                    className="text-center"
                    scope="col"

                  // onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
                  >
                    <span
                      role={tableHeader.value === '' ? "textbox" : "button"}
                      className={
                        tableHeader.value === '' ?
                          'fw-bold fs-6 lh-base' :
                          'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
                      }
                    >
                      {tableHeader.label}
                      {/* {queryParams.sort_by === tableHeader.value ? (
                          <i className={`bi ${queryParams.direction === 'desc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>
                        ) : null} */}
                    </span>
                  </th>
                ))}

              </tr>
            </thead>
            <tbody>
              {providerList && providerList.result.length > 0 &&
                providerList.result.map((item, key) =>
                  <tr key={key} className="align-middle">
                    <td className="text-center">
                      {/* <Link to={{ pathname: '/doctor_stats'
                      }} target="_blank"
                       className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover text-center" >
                        {item?.doctor_name} 
                      </Link> */}
                      <Link to={{
                        pathname: `/doctor_stats/${item.doctor_id}`,
                        search: objectToQueryString({

                          id: item.doctor_id,
                          type: "doctor",
                          role: "doctor",
                          start_date:defaultQueryParams?.start_date || "",
                          end_date:defaultQueryParams?.end_date || "",
                        })
                      }}
                        reloadDocument={true}
                        title={`Name: ${item?.practice_name ?? ""}\n\nAddress: ${item?.practice_full_address ?? ""}\n\nPhone: ${item?.practice_phone_number ?? ""}\n\nFax: ${item?.practice_fax_number ?? ""}`}
                        className="fw-normal fs-6 btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                      >
                        {item?.doctor_name}
                      </Link>
                      {item && isMobileOrTablet() &&
                        <PracticeContactInfo
                          children={<i className="bi bi-exclamation-circle-fill ms-1"></i>}
                          name={item?.practice_name ?? ""}
                          address={item?.practice_full_address ?? ""}
                          phone={item?.practice_phone_number ?? ""}
                          fax={item?.practice_fax_number ?? ""}
                          indexKey={key}
                        />
                      }
                    </td>
                    <td className="text-center"> {item.plan_type_data[0].count}</td>
                    <td className="text-center">{item.plan_type_data[1].count}</td>
                    <td className="text-center">{item?.plan_type_data[2].count}</td>
                    <td className="text-center">{item?.plan_type_data[3].count}</td>
                    <td className="text-center">{item?.plan_type_data[0].cases_total}</td>
                  </tr>
                )
              }
            </tbody>
            {/* <tfoot>
              <tr>
                <td className="fw-boldest text-center ">
                 Totals
                  </td>
                  <td className="fw-bold">{}</td>
                  <td className="fw-bold">{}</td>
                  <td className="fw-bold">{}</td>
                  <td className="fw-bold">{}</td>
                <td className="fw-bold  text-center">{providerList.total}</td>

              </tr>
            </tfoot> */}
            {(() => {
              // Totals
              const totals = [0, 0, 0, 0];

              providerList?.result?.forEach((item) => {
                item.plan_type_data.forEach((p, idx) => {
                  if (idx < 4) totals[idx] += p.count ?? 0;
                });
              });

              const hasAnyTotal = totals.some((val) => val > 0);

              return hasAnyTotal || providerList?.total > 0 ? (
                <tfoot>
                  <tr>
                    <td className="fw-boldest text-center">Totals</td>
                    {totals.map((val, i) => (
                      <td key={i} className="fw-bold text-center">
                        {val > 0 ? val : ""}
                      </td>
                    ))}
                    <td className="fw-bold text-center">
                      {providerList.total > 0 ? providerList.total : ""}
                    </td>
                  </tr>
                </tfoot>
              ) : null;
            })()}
          </table>
        </div>
      </div>
    </div>
  );
};
export default Provider;